import { Headset, Leaf, ShieldCheck, Truck } from "lucide-react";
import type { TrustItem } from "@/src/data/home";

type TrustBarProps = {
  items: TrustItem[];
};

const iconMap = {
  shield: ShieldCheck,
  truck: Truck,
  leaf: Leaf,
  support: Headset,
} as const;

export function TrustBar({ items }: TrustBarProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {items.map((item) => {
        const Icon = iconMap[item.icon];
        return (
          <article
            key={item.id}
            className="group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white/80 p-5 shadow-[0_14px_30px_rgba(30,41,59,0.11)] transition hover:-translate-y-1 hover:border-cyan-500/38"
          >
            <span className="pointer-events-none absolute -right-7 -top-9 h-20 w-20 rounded-full bg-cyan-300/22 blur-2xl transition group-hover:bg-cyan-300/32" />
            <div className="relative mb-3 inline-flex h-10 w-10 items-center justify-center rounded-xl border border-cyan-500/32 bg-cyan-100/85 text-cyan-800">
              <Icon className="h-4.5 w-4.5" />
            </div>
            <h3 className="relative text-base font-semibold text-slate-900">
              {item.title}
            </h3>
            <p className="relative mt-2 text-sm leading-relaxed text-slate-600">
              {item.copy}
            </p>
            <p className="relative mt-4 inline-flex rounded-full border border-slate-300/78 bg-white/82 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-cyan-700">
              {item.stat}
            </p>
          </article>
        );
      })}
    </div>
  );
}
